import { createRouter, createWebHistory } from 'vue-router'
import InterviewFormUserInfo from '@/views/interview/AdvanceForm/UserInfo'
import InterviewFormCancel from '@/views/interview/AdvanceForm/CancelInterview'
import InterviewRiskOfSerious from '@/views/interview/AdvanceForm/RiskOfSerious'
import InterviewMedical from '@/views/interview/AdvanceForm/MedicalInterview'
import InterviewTravelHistory from '@/views/interview/AdvanceForm/TravelHistory'
import IntensiveContact from '@/views/interview/AdvanceForm/IntensiveContact'
import IntensiveDetail from '@/views/interview/AdvanceDetail'
import InterviewConfirm from '@/views/interview/AdvanceConfirm'
import InterviewDone from '@/views/interview/AdvanceDone'
import RecordTime from '@/views/medicalRecord/RecordTime.vue'
import RecordConsultation from '@/views/medicalRecord/RecordConsultation.vue'
import RecordPatient from '@/views/medicalRecord/RecordPatient.vue'
import RecordAssessment from '@/views/medicalRecord/RecordAssessment.vue'
import RecordPlan from '@/views/medicalRecord/RecordPlan.vue'
import RecordConfirm from '@/views/medicalRecord/RecordConfirm.vue'
import RecordDone from '@/views/medicalRecord/RecordDone.vue'
import CsvDownload from '@/views/admins/CsvDownload';
import CovidCertificate from '@/views/admins/CovidCertificate';
import CovidCertificatePage from '@/views/interview/CovidCertificate';
import ErrorPage from '@/views/ErrorPage.vue';

const routes = [
  {
    path: '/interview',
    name: 'AdvanceInterviewForm',
    component: InterviewFormUserInfo
  },
  {
    path: '/interview/cancel/:code/:page',
    name: 'AdvanceInterviewCancel',
    component: InterviewFormCancel,
    props: true
  },
  {
    path: '/interview/confirm',
    name: 'AdvanceInterviewConfirm',
    component: InterviewConfirm
  },
  {
    path: '/interview/risk',
    name: 'AdvanceInterviewRiskOfSerious',
    component: InterviewRiskOfSerious
  },
  {
    path: '/interview/medical',
    name: 'AdvanceInterviewMedical',
    component: InterviewMedical
  },
  {
    path: '/interview/travel',
    name: 'InterviewTravelHistory',
    component: InterviewTravelHistory
  },
  {
    path: '/interview/contact',
    name: 'IntensiveContact',
    component: IntensiveContact
  },
  {
    path: '/interview/done',
    name: 'AdvanceInterviewDone',
    component: InterviewDone
  },
  {
    path: '/interview/:id',
    name: 'AdvanceInterviewDetail',
    component: IntensiveDetail
  },
  {
    path: '/record',
    name: 'RecordTime',
    component: RecordTime,
  },
  {
    path: '/record/patient',
    name: 'RecordPatient',
    component: RecordPatient,
  },
  {
    path: '/record/consultation',
    name: 'RecordConsultation',
    component: RecordConsultation,
  },
  {
    path: '/record/assessment',
    name: 'RecordAssessment',
    component: RecordAssessment,
  },
  {
    path: '/record/plan',
    name: 'RecordPlan',
    component: RecordPlan,
  },
  {
    path: '/record/confirm',
    name: 'RecordConfirm',
    component: RecordConfirm,
  },
  {
    path: '/record/done',
    name: 'RecordDone',
    component: RecordDone,
  },
  {
    path: '/admins/csv',
    name: 'AdminsCsvDownload',
    component: CsvDownload,
  },
  {
    path: '/admins/covid-certificate',
    name: 'AdminsCovidCertificate',
    component: CovidCertificate,
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage,
  },
  {
    path: '/interview/certificate',
    name: 'InterviewCertificate',
    component: CovidCertificatePage,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
